import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { CompanyStoreService } from '@fleet-beat/shared';

type CustomRouteOptions = [string] | [string, string | number];

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private readonly routePrefix: string = '/app/company/';

  constructor(private router: Router, private companyStoreService: CompanyStoreService) {}

  navigate(route: CustomRouteOptions, options?: NavigationExtras): void {
    const companyId: string = this.companyStoreService.companyId;
    const updatedRoute: CustomRouteOptions = [
      this.routePrefix + companyId + route[0],
      ...route.slice(1),
    ] as CustomRouteOptions;
    this.router.navigate(updatedRoute, { ...options });
  }
}
